import { useEffect, useState } from 'react';
import { useHead } from '../utils/seo/head';
import { fetchStoreDetails } from '../utils/storeDetails';
import { storeJsonLd } from '../utils/structuredData';
import STORE_HOURS from '../config/storeHours';

// The boutique's Store JSON-LD from the real Admin → Settings fields (phone,
// e-mail, address, TRN) and the confirmed opening hours. Rendered on the home
// page; nothing is emitted until the settings have loaded.
const StoreStructuredData = () => {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchStoreDetails().then((d) => { if (!cancelled) setDetails(d); });
    return () => { cancelled = true; };
  }, []);

  useHead(details ? { scripts: [JSON.stringify(storeJsonLd(details, STORE_HOURS))] } : null);
  return null;
};

export default StoreStructuredData;
